import React from 'react';
import './FuturePanel.css';

/**
 * Muted non-interactive placeholder for panels without ParsedGame backing.
 * Never shows plausible fake numbers (ADR 0011).
 */
function FuturePanel({ title, className = '', children }) {
  return (
    <div
      className={`future-panel ${className}`.trim()}
      aria-disabled="true"
      data-testid={`future-${(title || 'panel').toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="future-panel-badge">FUTURE</div>
      {title ? <div className="future-panel-title">{title}</div> : null}
      {children ? <div className="future-panel-body">{children}</div> : null}
    </div>
  );
}

export default FuturePanel;
